import { render } from "./OcrUploadFileGrid.vue?vue&type=template&id=888b7406"
import script from "./OcrUploadFileGrid.vue?vue&type=script&lang=js"
export * from "./OcrUploadFileGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__